export default "__VITE_ASSET__BKziwv65__"